import React from 'react';
import { Button } from '@economic/gaudi';

import { t } from '../../shared/components/l10n/l10n';
import welcome from './onboarding_welcome.png';

interface Props {
    displaySubcontent: boolean;
    onGettingStarted: () => void;
}

export default function StepWelcome({ displaySubcontent, onGettingStarted }: Props) {
    return (
        <div className="onboarding onboarding__welcome">
            <img src={welcome} alt="" className="onboarding__picture" />
            <h2>{t`ONBOARDING_GETTINGSTARTED_WELCOME_TITLE`}</h2>

            <p>{t`ONBOARDING_GETTINGSTARTED_WELCOME_CONTENT`}</p>

            {displaySubcontent && <p>{t`ONBOARDING_GETTINGSTARTED_WELCOME_SUBCONTENT`}</p>}

            <Button appearance="primary" onClick={() => onGettingStarted()}>
                {t`ONBOARDING_GETTINGSTARTED_WELCOME_CTA`}
            </Button>
        </div>
    );
}
